<template>
    <div id="contenedor-main-listado-obras">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop :listadoLicitaciones="listadoLicitaciones"></desktop>
        </template>
        <template
            v-else>
            <mobile :listadoLicitaciones="listadoLicitaciones"></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoObras',
  props: {
    listadoLicitaciones: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
